/**
 * Intersection Observer を使用したスクロールアニメーション制御（改良版）
 */
const initScrollAnimations = () => {
  // 管理画面（テーマエディタ）での処理
  const isDesignMode = window.Shopify && window.Shopify.designMode;

  const animationObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-animated');
        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -8% 0px',
    threshold: 0
  });

  const observeElements = () => {
    const elements = document.querySelectorAll('.js-scroll-animation:not(.is-animated)');
    elements.forEach(el => {
      // 管理画面ではアニメーションを待たずにクラス付与
      if (isDesignMode) {
        el.classList.add('is-animated');
      } else {
        animationObserver.observe(el);
      }
    });
  };

  // 初回実行
  observeElements();

  // 商品詳細ページのバリアント切り替えやアプリによる動的挿入に対応
  const dynamicObserver = new MutationObserver(() => {
    observeElements();
  });

  dynamicObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
};

// 実行タイミングの最適化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollAnimations);
} else {
  initScrollAnimations();
}

// Shopifyテーマエディタのセクション再読み込みに対応
document.addEventListener('shopify:section:load', (e) => {
  initScrollAnimations();
});

/**
 * 商品詳細ページのメディアギャラリー swiper.js (アニメーション調整版)
 */

// 読み込み時とセクション更新時に実行
document.addEventListener('DOMContentLoaded', initProductSwiper);
document.addEventListener('shopify:section:load', initProductSwiper);

// 動的なページ遷移（View Transitions等）や要素追加に対応するための監視設定
const swiperObserver = new MutationObserver((mutations) => {
  let shouldInit = false;
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length > 0) {
      shouldInit = true;
    }
  });
  if (shouldInit) {
    initProductSwiper();
  }
});

// body全体を監視開始
swiperObserver.observe(document.body, {
  childList: true,
  subtree: true
});

function initProductSwiper() {
  const sliders = document.querySelectorAll('.product-media-slider');

  sliders.forEach((sliderElement) => {
    // 既にSwiperが起動済みの場合はスキップ
    if (sliderElement.classList.contains('swiper-initialized')) return;

    // 1. 初期表示すべき画像IDを取得
    const initialMediaId = sliderElement.getAttribute('data-initial-media-id');
    let initialIndex = 0;

    // 2. IDに一致するスライドが何番目にあるか計算
    if (initialMediaId) {
      const targetSlide = sliderElement.querySelector(`.swiper-slide[data-media-id="${initialMediaId}"]`);
      if (targetSlide) {
        initialIndex = Array.from(targetSlide.parentNode.children).indexOf(targetSlide);
      }
    }

    // 3. Swiper初期化
    const swiper = new Swiper(sliderElement, {
      // 最初は必ず先頭(親画像)を表示しておく
      initialSlide: 0,

      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      loop: false,
      speed: 1000, // スライド速度を1秒に設定（よりゆっくり見せる）
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function (sw) {
          // 画像が2枚目以降にある場合のみ移動処理を実行
          if (initialIndex > 0) {
            console.log('Sliding to index:', initialIndex); // 動作確認用ログ

            // 0.5秒待ってから移動開始（画面描画の安定を待つ）
            setTimeout(() => {
              sw.slideTo(initialIndex, 1000, false);
            }, 500);
          }
        },
      },
    });
  });
}

// body全体を監視開始
swiperObserver.observe(document.body, {
  childList: true,
  subtree: true
});

function initProductSwiper() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initProductSwiper, 50);
    return;
  }

  const sliders = document.querySelectorAll('.product-media-slider');

  sliders.forEach((sliderElement) => {
    // 既にSwiperが起動済みの場合はスキップ
    if (sliderElement.classList.contains('swiper-initialized')) return;

    // 1. 初期表示すべき画像IDを取得
    const initialMediaId = sliderElement.getAttribute('data-initial-media-id');
    let initialIndex = 0;

    // 2. IDに一致するスライドが何番目にあるか計算
    if (initialMediaId) {
      const targetSlide = sliderElement.querySelector(`.swiper-slide[data-media-id="${initialMediaId}"]`);
      if (targetSlide) {
        initialIndex = Array.from(targetSlide.parentNode.children).indexOf(targetSlide);
      }
    }

    // 3. Swiper初期化
    const swiper = new Swiper(sliderElement, {
      // 最初は必ず先頭(親画像)を表示しておく
      initialSlide: 0,

      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      loop: false,
      speed: 1000, // スライド速度を1秒に設定（よりゆっくり見せる）
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function (sw) {
          // 画像が2枚目以降にある場合のみ移動処理を実行
          if (initialIndex > 0) {
            console.log('Sliding to index:', initialIndex); // 動作確認用ログ

            // 0.5秒待ってから移動開始（画面描画の安定を待つ）
            setTimeout(() => {
              sw.slideTo(initialIndex, 1000, false);
            }, 500);
          }
        },
      },
    });
  });
}

/**
 * horizonデフォルトのスライダー制御
 */

//矢印クリック時のスクロール方向逆転
const unlockSlideshowControls = (slideshow) => {
  const prev = slideshow.querySelector('.slideshow-control--previous');
  const next = slideshow.querySelector('.slideshow-control--next');

  if (prev) prev.disabled = false;
  if (next) next.disabled = false;
};

document.addEventListener('slideshow:select', (e) => {
  const slideshow = e.target;
  unlockSlideshowControls(slideshow);
});

//disabled解除
const unlockAllSlideshows = () => {
  document
    .querySelectorAll('slideshow-component')
    .forEach((slideshow) => {
      slideshow
        .querySelectorAll(
          '.slideshow-control--previous, .slideshow-control--next'
        )
        .forEach((btn) => (btn.disabled = false));
    });
};

window.addEventListener('load', () => {
  requestAnimationFrame(() => {
    unlockAllSlideshows();
  });
});

//1枚ずつ切り替え
(() => {
  const unlock = (slideshow) => {
    slideshow
      .querySelectorAll('.slideshow-control--previous, .slideshow-control--next')
      .forEach((btn) => (btn.disabled = false));
  };

  const moveByOne = (slideshow, direction) => {
    const current = slideshow.current ?? 0;
    slideshow.select(current + direction, null, {animate: true});
  };

  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest(
        '.slideshow-control--previous, .slideshow-control--next'
      );
      if (!btn) return;

      const slideshow = btn.closest('slideshow-component');
      if (!slideshow) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      unlock(slideshow);

      if (btn.classList.contains('slideshow-control--previous')) {
        moveByOne(slideshow, +1);
      } else {
        moveByOne(slideshow, -1);
      }
    },
    true
  );

  const unlockAll = () => {
    document
      .querySelectorAll('slideshow-component')
      .forEach(unlock);
  };

  window.addEventListener('load', () => {
    requestAnimationFrame(unlockAll);
  });

  document.addEventListener('slideshow:select', (e) => {
    if (e.target?.tagName === 'SLIDESHOW-COMPONENT') {
      unlock(e.target);
    }
  });
})();

// レビューアプリ
function initReviewApp() {
  let product_review_handler = '[id^="shopify-section-template"][id$="mxpr-product-reviews"]';
  let targetSection = document.querySelector(product_review_handler);

  // セクションが存在しない場合は処理を中断
  if (!targetSection) return;

// 閉じるボタンの注入（まだ追加されていない場合のみ）
  if (!targetSection.querySelector('.product-review__close')) {

    const iconUrl = window.themeAssets?.arrow_down_03;

    targetSection.insertAdjacentHTML(
      "afterbegin",
      `<span class="product-review__close">
       <img src="${iconUrl}" alt="CLOSE">
     </span>`
    );
  }

  // 背景要素の注入（まだ追加されていない場合のみ）
  if (!document.querySelector('.product-review___back')) {
    targetSection.insertAdjacentHTML(
      "afterend",
      '<div class="product-review___back"></div>'
    );
  }

  // イベントリスナーの重複登録を防ぐために .off("click") を挟んで登録
  $(".js-review-trigger").off("click").on("click", function () {
    $("body").toggleClass("product-review--open overflow-hidden");
    $(product_review_handler).toggleClass("is-open");
    $(".product-review___back").toggleClass("is-open");
  });

  $(document).off("click", ".product-review__close").on("click", ".product-review__close", function () {
    $("body").removeClass("product-review--open overflow-hidden");
    $(product_review_handler).removeClass("is-open");
    $(".product-review___back").removeClass("is-open");
  });

  $(document).off("click", ".product-review___back").on("click", ".product-review___back", function () {
    $("body").removeClass("product-review--open overflow-hidden");
    $(product_review_handler).removeClass("is-open");
    $(".product-review___back").removeClass("is-open");
  });
}

// ① 初回読み込み時の実行
document.addEventListener('DOMContentLoaded', initReviewApp);

// ② バリエーション変更時の再実行
// 通信完了（DOMの書き換え完了）のタイミングが予測できないため、
// setIntervalを使用して約1.5秒間の間に複数回チェックして注入を試みる設計に変更
function onVariantChange() {
  let checkCount = 0;
  const intervalId = setInterval(() => {
    initReviewApp();
    checkCount++;
    // 300ms × 6回 = 約1.8秒間チェックしたら監視を終了する
    if (checkCount >= 6) {
      clearInterval(intervalId);
    }
  }, 300);
}

if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
} else {
  // 万が一PubSubが使えない場合のフォールバック
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-radios, variant-selects, .variant-picker')) {
      onVariantChange();
    }
  });
}

//コーデバイスライドカスタマイズ
$(function () {
  const initScrollNav = () => {
    const $container = $('#js-code-item-use.sp-horizontal-scroll');
    if ($container.length === 0 || $container.children().length === 0) return;

    const $parent = $container.closest('.l-codebuy__container');
    if ($parent.find('.js-sp-nav-wrapper').length > 0) return;

    const navHtml = `
      <div class="sp-scroll-nav-wrapper js-sp-nav-wrapper">
        <button type="button" class="sp-scroll-nav__btn prev js-scroll-prev" aria-label="Previous">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
        <button type="button" class="sp-scroll-nav__btn next js-scroll-next" aria-label="Next">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>
        </button>
      </div>
    `;

    $container.before(navHtml);
    const $wrapper = $parent.find('.js-sp-nav-wrapper');

    // 画像部分の高さを取得して、矢印を中央に配置する関数
    const adjustArrowPosition = () => {
      // 最初の商品の画像ラッパーを取得
      const $thumbnail = $container.find('.p-codebuy__typeA_thumbnail').first();
      if ($thumbnail.length) {
        // 画像ラッパーの高さの半分を計算（＝画像の中央Y座標）
        const imgCenterY = $thumbnail.outerHeight() / 2;
        // ボタンの top に計算したピクセル値をセット
        $wrapper.find('.sp-scroll-nav__btn').css('top', `${imgCenterY}px`);
      }
    };

    // 初回実行
    adjustArrowPosition();

    // 画面の向きが変わった際（スマホの縦横回転）にも再計算して追従させる
    $(window).on('resize', adjustArrowPosition);

    // 画像の読み込みが遅れた場合を考慮し、念のため少し後にもう一度計算
    setTimeout(adjustArrowPosition, 500);

    let isAnimating = false; // 連打防止フラグ

    // 移動量を計算（カード1枚分の幅 × 2枚分スクロールする設定）
    const getScrollStep = () => {
      const $firstCard = $container.children('.l-codebuy__column').first();
      // カードが取得できれば「カード幅×2」、取得できなければ「表示領域の80%」を移動量とする
      return $firstCard.length ? $firstCard.outerWidth(true) * 2 : $container.outerWidth() * 0.8;
    };

    const executeScroll = (direction) => {
      if (isAnimating) return;
      isAnimating = true;

      const step = getScrollStep() * direction;

      // 【重要】スクロールスナップを一時解除して、ガタつきと無限スクロールバグを防ぐ
      $container.css('scroll-snap-type', 'none');

      // jQueryで滑らかにアニメーション
      $container.stop().animate({
        scrollLeft: $container.scrollLeft() + step
      }, 350, 'swing', function () {
        // アニメーション完了後にスナップを再有効化し、ズレを補正
        $container.css('scroll-snap-type', '');
        isAnimating = false;
      });
    };

    $wrapper.find('.js-scroll-next').on('click', () => executeScroll(1));
    $wrapper.find('.js-scroll-prev').on('click', () => executeScroll(-1));

    $container.on('scroll', function () {
      if (isAnimating) return; // アニメーション中は透過処理を休ませて軽くする
      const currentLeft = $(this).scrollLeft();
      const maxScroll = this.scrollWidth - this.clientWidth;
      $wrapper.find('.js-scroll-prev').css('opacity', currentLeft > 10 ? '1' : '0.3');
      $wrapper.find('.js-scroll-next').css('opacity', currentLeft < maxScroll - 10 ? '1' : '0.3');
    }).trigger('scroll');
  };

  const observer = new MutationObserver(() => {
    initScrollNav();
  });

  const observeTarget = document.querySelector('.p-codebuy__section--useproduct') || document.body;
  if (observeTarget) {
    observer.observe(observeTarget, {
      childList: true,
      subtree: true
    });
  }

  initScrollNav();
});

/*****************iOS Safari判定*******************/
document.addEventListener("DOMContentLoaded", () => {
  const ua = navigator.userAgent.toLowerCase();
  const body = document.body;

  if (/iphone|ipad|ipod/.test(ua)) {
    body.classList.add("ios");

    // iOS バージョンを抽出
    const match = ua.match(/os (\d+)_/);
    if (match && match[1]) {
      body.classList.add(`ios${match[1]}`);
    }

    // iOS Safari 判定
    // Chrome for iOS → "crios" が含まれる
    // Firefox for iOS → "fxios" が含まれる
    // Safariのみ → "safari" を含み、かつ crios/fxios を含まない
    if (/safari/.test(ua) && !/crios|fxios/.test(ua)) {
      body.classList.add("safari");
    }
  }
});